import CustomerIcon from '@mui/icons-material/Group'; // Use appropriate icon

import UnregisteredList from './UnregisteredList';

export default {
    list: UnregisteredList,
    icon: CustomerIcon,
};